import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { statusOptions, yesNoOptions } from '../../../utils/mics';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';

const PosJournalFilter = (props) => {

    const dispatch = useDispatch();

    const filters = useSelector((state) => state.posJournal.filters);

    const { handleSearch, handleReset, onFormValuesChange } = props;
    
    const formik = useFormik({
        initialValues: {
            fileId: filters?.fileId || '',
            storeId: filters?.storeId || '',
            terminalId: filters?.terminalId || '',
            operatorId: filters?.operatorId || '',
            date_from: filters?.date_from || '',
            date_till: filters?.date_till || '',
            trxType: filters?.trxType || '',
            trxDate: filters?.trxDate || '',
            trxTime: filters?.trxTime || '',
            trxId: filters?.trxId || '',
            pjoXmlFileId: filters?.pjoXmlFileId || '',
            eodXmlFileId: filters?.eodXmlFileId || '',
            error: filters?.error || '',
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                date_from: values.date_from ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
                trxDate: values.trxDate ? moment(values.trxDate).format('YYYY-MM-DD') : '',
                trxTime: values.trxTime ? moment(values.trxTime).format('HH:mm:ss') : '',
            };
            dispatch(appActions.POSJOURNAL_SET_FILTERS_REQUEST(values));
            handleSearch(data);
        },
    });

    const handleClear = () => {
        dispatch(appActions.POSJOURNAL_SET_FILTERS_REQUEST({}));
        formik.resetForm();
        onFormValuesChange(null);
        handleReset();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        formik.handleChange(e);

        if (onFormValuesChange) {
            const updatedValues = { ...formik.values, [name]: value };
            const formattedData = {
                ...updatedValues,
                date_from: updatedValues.date_from ? moment(updatedValues.date_from).format('YYYY-MM-DD') : '',
                date_till: updatedValues.date_till ? moment(updatedValues.date_till).format('YYYY-MM-DD') : '',
                trxDate: updatedValues.trxDate ? moment(updatedValues.trxDate).format('YYYY-MM-DD') : '',
                trxTime: updatedValues.trxTime ? moment(updatedValues.trxTime).format('HH:mm:ss') : '',
            };
            onFormValuesChange(formattedData);
        }
    };

    const isDateTillUpdated = useRef(false); // Track if update is needed

    useEffect(() => {
        if (
            formik.values.date_from &&
            (!formik.values.date_till || new Date(formik.values.date_till) < new Date(formik.values.date_from))
        ) {
            if (!isDateTillUpdated.current) { // Prevent infinite loop
                formik.setFieldValue("date_till", formik.values.date_from);
                isDateTillUpdated.current = true; // Mark as updated
            }
        } else {
            isDateTillUpdated.current = false; // Reset when update is not needed
        }
    }, [formik, formik.values.date_from]); // Only trigger when date_from changes


    const renderFormArea = () => {
        return (
            <>
                <div className="p-fluid formgrid grid w-full">
                    <div className="field col-12 md:col-3">
                        <label htmlFor="fileId">File Id</label>
                        <InputText id="fileId" name="fileId" type="text" value={formik.values.fileId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="storeId">Store Id</label>
                        <InputText id="storeId" name="storeId" type="text" value={formik.values.storeId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="trxId">Trx Id</label>
                        <InputText id="trxId" name="trxId" type="text" value={formik.values.trxId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="trxType">Trx Type</label>
                        <InputText id="trxType" name="trxType" type="text" value={formik.values.trxType} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="terminalId">Terminal Id</label>
                        <InputText id="terminalId" name="terminalId" type="text" value={formik.values.terminalId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="operatorId">Operator Id</label>
                        <InputText id="operatorId" name="operatorId" type="text" value={formik.values.operatorId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="trxDate">Trx Date</label>
                        <Calendar id="trxDate" name="trxDate" value={formik.values.trxDate} onChange={handleChange} dateFormat="dd-mm-yy" showIcon />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="trxTime">Trx Time</label>
                        <Calendar id="trxTime" name="trxTime" value={formik.values.trxTime} onChange={handleChange} timeOnly hourFormat="24" />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="status">Status</label>
                        <Dropdown filter showClear value={formik.values.status} onChange={handleChange} options={statusOptions}  id="status" name="status" optionLabel="name" optionValue='name' placeholder="Select status"  />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="error">Error</label>
                        <InputText id="error" name="error" type="text" value={formik.values.error} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="pjoxmlStatus">PJO XML Status</label>
                        <Dropdown filter showClear value={formik.values.pjoxmlStatus} onChange={handleChange} options={yesNoOptions} id="pjoxmlStatus" name="pjoxmlStatus" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="eodxmlStatus">EOD XML Status</label>
                        <Dropdown filter showClear value={formik.values.eodxmlStatus} onChange={handleChange} options={yesNoOptions} id="eodxmlStatus" name="eodxmlStatus" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="pjoXmlFileId">PJO XML File Id</label>
                        <InputText id="pjoXmlFileId" name="pjoXmlFileId" type="text" value={formik.values.pjoXmlFileId} onChange={handleChange} />
                    </div>
                      <div className="field col-12 md:col-3">
                        <label htmlFor="eodXmlFileId">EOD XML File Id</label>
                        <InputText id="pjoXmlFeodXmlFileIdileId" name="eodXmlFileId" type="text" value={formik.values.eodXmlFileId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date From</label>
                        <Calendar id="date_from" name="date_from" value={formik.values.date_from} onChange={handleChange} dateFormat="dd-mm-yy" showIcon maxDate={new Date()}/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date Till</label>
                        <Calendar id="date_till" name="date_till" value={formik.values.date_till} onChange={handleChange} dateFormat="dd-mm-yy" showIcon minDate={formik.values.date_from} />
                    </div>
                </div>
                <div className="grid px-2 py-4 flex-row-reverse gap-10">
                    <Button type="submit" icon="pi pi-search" label="Search" severity="success" outlined className="p-button-success mr-2 tp" data-pr-tooltip="Search" />
                    <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset Filter" label="Reset Filter" severity="secondary" outlined onClick={handleClear} />
                </div>
            </>
        );
    };
    return <form onSubmit={formik.handleSubmit}>{renderFormArea()}</form>;
};

export default PosJournalFilter;
